export default theme => ({
  root: {
    boxSizing: 'border-box',
    height: '100%',
    '& .react-grid-placeholder': {
      background: theme.colors.semantic.infoCustom100
    }
  },
  gridItem: {
    borderRadius: '8px',
    boxShadow: '0px 0px 2px 0px rgba(39, 60, 80, 0.14), 0px 2px 2px 0px rgba(39, 60, 80, 0.12), 0px 1px 3px 0px rgba(39, 60, 80, 0.20)',
    boxSizing: 'border-box',
    border: '1px solid transparent',
    backgroundColor: theme.colors.primary.white,
    '& .react-resizable-handle': {
      backgroundImage: 'none',
      '&:after': {
        display: 'none'
      },
      '&.react-resizable-handle-s': {
        display: 'none'
      },
      '&.react-resizable-handle-w': {
        display: 'none'
      },
      '&.react-resizable-handle-e': {
        display: 'none'
      },
      '&.react-resizable-handle-n': {
        display: 'none'
      },
      '&.react-resizable-handle-sw': {
        '&:after': {
          width: '9px',
          height: '9px',
          borderRight: '2px solid rgba(0, 0, 0, 0.15)',
          borderBottom: '2px solid rgba(0, 0, 0, 0.15)'
        }
      },
      '&.react-resizable-handle-nw': {
        '&:after': {
          width: '9px',
          height: '9px',
          borderRight: '2px solid rgba(0, 0, 0, 0.15)',
          borderBottom: '2px solid rgba(0, 0, 0, 0.15)'
        }
      },
      '&.react-resizable-handle-se': {
        '&:after': {
          width: '9px',
          height: '9px',
          borderRight: '2px solid rgba(0, 0, 0, 0.15)',
          borderBottom: '2px solid rgba(0, 0, 0, 0.15)'
        }
      },
      '&.react-resizable-handle-ne': {
        '&:after': {
          width: '9px',
          height: '9px',
          borderRight: '2px solid rgba(0, 0, 0, 0.15)',
          borderBottom: '2px solid rgba(0, 0, 0, 0.15)'
        }
      }
    },
    '&:hover': {
      '& .react-resizable-handle': {
        backgroundImage: 'none',
        '&:after': {
          display: 'block'
        }
      }
    }
  },
  selected: {
    border: `1px solid ${theme.colors.actionMajor[500]}`,
    boxShadow: `0px 4px 10px ${theme.colors.actionMajor[500]}33` //33 stands for 20% alpha
  }
});